/**
 * @author Ilya Aderiho.
 */
var DetailSamplingController = (function () {
    function DetailSamplingController(topic, env, socket, $scope, notify, $window) {
        var _this = this;
        this.topic = topic;
        this.env = env;
        this.socket = socket;
        this.$scope = $scope;
        this.notify = notify;
        this.$window = $window;
        this.incentive = ['SSA', 'Solution'];
        this.selectedInc = 'SSA';
        this.OPP_VERSION_3 = 3;
        this.OPP_VERSION_4 = 4;
        this.OPP_VERSION_5 = 5;
        this.isDocumentationStatusUpdating = false;
        this.documentationStatusValues = ['Not Provided', 'Need More Evidence', 'Submitted', 'Reviewed'];
        this.selectedInc = 'SSA';
        this.uiVersion = this.topic.checksData.uiVersion;
        if (this.topic.checksData.inbound && this.topic.checksData.inbound.incentive) {
            // on initialize emit  to the detail/
            this.socket.emit('module', {
                module: {
                    application: 'dmt',
                    function: 'getSpecialBidUpdatesPRM',
                    script: '/detail/sampling/sampling',
                    user: this.env.user,
                    data: {
                        incentive: this.topic.checksData.inbound.incentive,
                        groupIds: Object.keys(this.topic.compareGpp.gpp)
                    }
                }
            });
            this.socket.forward('fetch.detail_sampling', this.$scope);
            this.$scope.$on('socket:fetch.detail_sampling', function (event, data) {
                // collect the update history from caseId
                _this.caseIdPRMs = data.collectCaseIdPRM;
            });
        }
        this.socket.forward('update.documentation.status', this.$scope);
        this.$scope.$on('socket:update.documentation.status', function (event, data) {
            _this.isDocumentationStatusUpdating = false;
            if (data.success) {
                _this.notify.success('Documentation Status updated successfully');
            }
            else {
                _this.notify.error(data.error);
            }
            _this.$window.location.reload();
        });
    }
    DetailSamplingController.prototype.switchTable = function (inc) {
        this.selectedInc = inc;
    };
    DetailSamplingController.prototype.$onInit = function () {
        this.selectedInc = 'SSA';
        // this.isDocumentationStatusChanged = false;
        // this.commonDocumentationStatus = this.topic.topic.sampling.documentationStatus || 'Not Provided';
        // this.initialCommonDocumentationStatus = this.documentationStatus;
        this.engagementDocumentationStatusOnLoad = _.get(this, 'topic.topic.sampling.Solution.documentationStatus') || 'Not Provided';
        this.salesDocumentationStatusOnLoad = _.get(this, 'topic.topic.sampling.SSA.documentationStatus') || 'Not Provided';
        this.engagementDocumentationStatus = this.engagementDocumentationStatusOnLoad;
        this.salesDocumentationStatus = this.salesDocumentationStatusOnLoad;
    };
    DetailSamplingController.prototype.getInc = function () {
        return this.selectedInc;
    };
    DetailSamplingController.prototype.isIncEmpty = function () {
        return (!this.topic.topic.sampling.Solution && !this.topic.topic.sampling.SSA) ||
            ((this.topic.topic.sampling.Solution && this.topic.topic.sampling.Solution.samplingStatus === 'untested') &&
                (this.topic.topic.sampling.SSA && this.topic.topic.sampling.SSA.samplingStatus === 'untested'));
    };
    DetailSamplingController.prototype.saveEngagementDocumentationStatus = function () {
        this.updateDocumentationStatus('Solution', this.engagementDocumentationStatus);
    };
    DetailSamplingController.prototype.saveSalesDocumentationStatus = function () {
        this.updateDocumentationStatus('SSA', this.salesDocumentationStatus);
    };
    DetailSamplingController.prototype.changeCurrentEngagementDocumentationStatus = function () {
        this.isEngagementDocumentationStatusChanged = (this.engagementDocumentationStatusOnLoad !== this.engagementDocumentationStatus);
    };
    DetailSamplingController.prototype.changeCurrentSalesDocumentationStatus = function () {
        this.isSalesDocumentationStatusChanged = (this.salesDocumentationStatusOnLoad !== this.salesDocumentationStatus);
    };
    DetailSamplingController.prototype.isSamplingActive = function (incentive) {
        return _.get(this, "topic.topic.sampling." + incentive + ".samplingStatus") === 'Manually sampled - In Progress';
    };
    DetailSamplingController.prototype.updateDocumentationStatus = function (incentiveType, value) {
        this.isDocumentationStatusUpdating = true;
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'updateDocumentationStatus',
                script: '/detail/sampling/sampling',
                data: {
                    incentiveType: incentiveType,
                    value: value,
                    opportunityId: this.topic.topic._id
                },
                user: this.env.user,
                bID: this.topic.topicBrowserID //Need this to be able to utilise the update.partial socket
            }
        });
    };
    DetailSamplingController.$inject = ['topic', 'env', 'socket', '$scope', 'notify', '$window'];
    return DetailSamplingController;
}());
var DetailSamplingComponent = (function () {
    function DetailSamplingComponent() {
        this.templateUrl = 'detail-sampling.html';
        this.controllerAs = 'vm';
        this.controller = DetailSamplingController;
    }
    return DetailSamplingComponent;
}());
angular
    .module('application')
    .component('detailSampling', new DetailSamplingComponent());

//# sourceMappingURL=detail.sampling.component.js.map
